import angular from 'angular';
import moment from 'moment';
import 'moment-timezone';

angular.module('app.filters.datetime', [])
    .filter('blndDt', function () {
        return function (item) {
            if (!item) {
                return 'N/A';
            }
            const parsedDt = moment.utc(item, "YYYY-MM-DDTHH:mm:ss.SSSSZ", true);
            return parsedDt.isValid() ? parsedDt.tz('US/Eastern').format('L LT') : item;
        };
    })
    .filter('blndTimeAgo', function () {
        return function (item) {
            if (!item) {
                return 'N/A';
            }
            return moment.utc(item).tz('US/Eastern').fromNow();
        };
    })
    .filter('blndDate', function () {
        return function (item) {
            if (!item) {
                return 'N/A';
            }
            return moment.utc(item).tz('US/Eastern').format('L');
        };
    });



// WEBPACK FOOTER //
// ./src/app/filters/datetime.js